import React from 'react';
import { CrossTab32 } from '@carbon/icons-react';
import UpsellScreen from '#coreComponents/UpsellScreen';

const items = ['Key institutional data across sdgs'];
const SdgUpsell = () => (
  <UpsellScreen>
    <UpsellScreen.Icon component={CrossTab32} />
    <UpsellScreen.Title>
      Dive into the key statistics of your sdg impact.
    </UpsellScreen.Title>
    <UpsellScreen.List items={items} />
  </UpsellScreen>
);

export default SdgUpsell;
